import React, { useEffect, useMemo, useRef } from 'react';
import styles from './styles';
import { useNavigate } from 'react-router';
import Button from '@/components/input/Button';

const DAY_NAMES = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

function getDaysAround(date: Date, range: number = 2): Date[] {
  const days: Date[] = [];
  for (let i = -range; i <= range; i++) {
    const d = new Date(date);
    d.setDate(date.getDate() + i);
    days.push(d);
  }
  return days;
}

function formatDayOfWeek(date: Date): string {
  return DAY_NAMES[date.getDay()];
}

function formatDayNumber(date: Date): number {
  return date.getDate();
}

export default function DailyCarousel() {
  const navigate = useNavigate();
  const today = useMemo(() => new Date(), []);
  const days = useMemo(() => getDaysAround(today, 2), [today]);
  const itemsRef = useRef<(HTMLDivElement | null)[]>([]);

  const itemWidth = `${100 / 5}%`; // Visible 5 items

  const handlePress = () => {
    navigate('/records/daily-intro');
  };

  useEffect(() => {
    itemsRef.current[2]?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.carouselScroll}>
        {days.map((item, index) => {
          const isToday = item.toDateString() === today.toDateString();
          return (
            <div
              key={item.toISOString()}
              ref={(el) => {
                itemsRef.current[index] = el;
              }}
              style={{
                ...styles.itemContainer,
                width: itemWidth,
                ...(isToday ? styles.itemSelected : {}),
              }}
            >
              <div
                style={{
                  ...styles.dayName,
                  ...(isToday ? styles.dayNameSelected : {}),
                }}
              >
                {formatDayOfWeek(item)}
              </div>
              <div
                style={{
                  ...styles.dayCircle,
                  ...(isToday ? styles.dayCircleSelected : {}),
                }}
              >
                <div style={styles.dayNumber}>{formatDayNumber(item)}</div>
              </div>
            </div>
          );
        })}
      </div>
      <Button sx={{ fontWeight: 'bold', justifyContent: 'center', marginTop: 16 , width: '100%' }} onClick={handlePress}>
        Registrar Día
      </Button>
    </div>
  );
}
